import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from './constants';
import { preventDefault } from '~/__modules__/browser';

Calendar.propTypes = {
  format: PropTypes.string,
  date: PropTypes.string.isRequired,
  onChangeDate: PropTypes.func.isRequired,
};
export default function Calendar({ format = DATE_FORMAT, date, onChangeDate }) {
  const { t } = useTranslation();

  const todayDateTime = DateTime.local();
  const selectedDateTime = DateTime.fromFormat(date, format).isValid
    ? DateTime.fromFormat(date, format)
    : todayDateTime;
  const [visibleDateTime, setVisibleDateTime] = useState(selectedDateTime);

  const handleClickNav = (delta) => () => {
    setVisibleDateTime(visibleDateTime.plus(delta));
  };
  const handleClickDay = (date) => () => onChangeDate(date);

  return (
    <div className="basic_calendar">
      <div className="move_month">
        <a
          href="#"
          className="calendar-btn-prev-year"
          onClick={preventDefault(handleClickNav({ years: -1 }))}
        >
          <span className="blind">{t('calendar_previous_year')}</span>
        </a>
        <a
          href="#"
          className="calendar-btn-prev-mon"
          onClick={preventDefault(handleClickNav({ months: -1 }))}
        >
          <span className="blind">{t('calendar_previous_month')}</span>
        </a>
        <strong className="calendar-title">
          {visibleDateTime.year}.{visibleDateTime.month}
        </strong>
        <a
          href="#"
          className="calendar-btn-next-mon"
          onClick={preventDefault(handleClickNav({ months: 1 }))}
        >
          <span className="blind">{t('calendar_next_month')}</span>
        </a>
        <a
          href="#"
          className="calendar-btn-next-year"
          onClick={preventDefault(handleClickNav({ years: 1 }))}
        >
          <span className="blind">{t('calendar_next_year')}</span>
        </a>
      </div>
      <table>
        <caption>
          <span className="blind">{t('caledar_title')}</span>
        </caption>
        <colgroup>
          <col width="25" span="7" />
        </colgroup>
        <thead>
          <tr>
            <th className="sun" scope="col">
              {t('calendar_day_sun')}
            </th>
            <th scope="col">{t('calendar_day_mon')}</th>
            <th scope="col">{t('calendar_day_tue')}</th>
            <th scope="col">{t('calendar_day_wed')}</th>
            <th scope="col">{t('calendar_day_thu')}</th>
            <th scope="col">{t('calendar_day_fri')}</th>
            <th className="sat" scope="col">
              {t('calendar_day_sat')}
            </th>
          </tr>
        </thead>
        <tbody>
          {buildWeeksThatStartsOnSunday(
            visibleDateTime.year,
            visibleDateTime.month,
          ).map((week, weekIndex) => (
            <tr
              key={visibleDateTime.toFormat(`yyyyLL${weekIndex}`)}
              className="calendar-week"
            >
              {week.map(({ year, month, day }, weekday) => {
                const dayDateTime = DateTime.local(year, month, day);
                const dayString = dayDateTime.toFormat(format);
                return (
                  <td
                    key={dayString}
                    className={classNames({
                      'calendar-sun': weekday === 0,
                      'calendar-sat': weekday === 6,
                      'calendar-prev-mon': month < visibleDateTime.month,
                      'calendar-next-mon': month > visibleDateTime.month,
                      'calendar-today': dayDateTime.hasSame(
                        todayDateTime,
                        'day',
                      ),
                      'calendar-selected': dayDateTime.hasSame(
                        selectedDateTime,
                        'day',
                      ),
                    })}
                  >
                    <a
                      href="#"
                      className="calendar-date"
                      onClick={preventDefault(handleClickDay(dayString))}
                    >
                      {day}
                    </a>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {/* <div className="date">
        <a
          href="#"
          className="utx_btn_b"
          onClick={preventDefault(handleClickDay(todayDateTime.toISODate()))}
        >
          <span className="utx_inrbtn">{t('common.today')}</span>
        </a>
      </div> */}
    </div>
  );
}

export function buildWeeksThatStartsOnSunday(year, month) {
  const monthDateTime = DateTime.local(year, month);
  const daysInWeekCount = 7;
  const monthFirstWeekday = monthDateTime.weekday % daysInWeekCount;
  const monthLastWeekday =
    monthDateTime.endOf('month').weekday % daysInWeekCount;
  const daysCount =
    monthFirstWeekday +
    monthDateTime.daysInMonth +
    (daysInWeekCount - 1 - monthLastWeekday);
  const startDayDateTime = monthDateTime.minus({ days: monthFirstWeekday });

  return Array.from(Array(daysCount / daysInWeekCount), (_, i) => {
    return Array.from(Array(daysInWeekCount), (_, j) => {
      const { year, month, day } = startDayDateTime.plus({
        days: i * daysInWeekCount + j,
      });
      return { year, month, day };
    });
  });
}
